<div class="header">
  <img [src]="icons.logo" [style.visibility]="logoVisible ? 'visible' : 'hidden'" alt="" [routerLink]="['/']" style="cursor: pointer;">
  <div class="menu" [class.no-bg]="menuOpen" (click)="toggleMenu()">

    <img [src]="icons.perfil" alt="">
    <span>DRAM CÁPITAL</span>
    <img [src]="icons.bars">

    <div class="menu-abierto" [class.open]="menuOpen" (click)="$event.stopPropagation()">

      <div class="header-inside">
        <img [src]="icons.whitelogo" alt="">
        <div class="dram-header-title-navbar">
          <img [src]="icons.perfil" alt="">
          <span>DRAM CÁPITAL</span>
          <img [src]="icons.x" alt="" (click)="closeMenu(); $event.stopPropagation()">
        </div>
      </div>

      <div class="division-line"></div>

      <div class="menu-items">
        <a href="#cotizar" (click)="closeMenu(); $event.stopPropagation()">Cotizar</a>
        <a href="#funciona" (click)="closeMenu(); $event.stopPropagation()">Como funciona</a>
        <a href="#posibilidades" (click)="closeMenu(); $event.stopPropagation()">Posibilidades</a>
        <!-- <a href="#educacion" (click)="closeMenu(); $event.stopPropagation()">Educación financiera</a> -->
      </div>

      <div class="division-line"></div>

      <div class="menu-items">
        <a [routerLink]="['/log-in']" (click)="closeMenu(); $event.stopPropagation(); goToPortal();">Iniciar sesión</a>
      </div>

      <button-credito
        (click)="closeMenu(); $event.stopPropagation()"
        [texto]="'Solicitar crédito'"
      ></button-credito>

    </div>

  </div>

  <div
      class="menu-overlay"
      *ngIf="menuOpen"
      (click)="closeMenu()">
    </div>
</div>
